var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2345 0.410765C12.5599 0.736202 12.5599 1.26384 12.2345 1.58928L7.50116 6.32261L12.2345 11.0559C12.5599 11.3814 12.5599 11.909 12.2345 12.2345C11.9091 12.5599 11.3814 12.5599 11.056 12.2345L6.32265 7.50112L1.58934 12.2344C1.2639 12.5599 0.736263 12.5599 0.410826 12.2344C0.0853888 11.909 0.0853888 11.3814 0.410826 11.0559L5.14414 6.32261L0.410826 1.5893C0.0853888 1.26386 0.0853888 0.736222 0.410826 0.410785C0.736263 0.0853481 1.2639 0.0853481 1.58934 0.410785L6.32265 5.1441L11.056 0.410765C11.3814 0.0853278 11.9091 0.0853278 12.2345 0.410765Z",
    fill: "#CA2867"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/RedCross.29f443571c47f5ea1ad60111eb9cb78d.svg";
export { ForwardRef as ReactComponent };